import { createGlobalStyle } from 'styled-components';
import { theme } from 'styled-tools';
import {
  NotoSansCJKkrBold,
  NotoSansCJKkrRegular,
  PoppinsBold,
  PoppinsRegular,
  ErasITCBold
} from 'assets/fonts/fonts';
import 'animate.css';
import "antd/dist/antd.css";

const GlobalStyles = createGlobalStyle`

@font-face {
    font-family: 'NotoSansCJKkr-Regular';
    src: local('NotoSansCJKkr-Regular'), url(${NotoSansCJKkrRegular}) format('woff');
}

@font-face {
    font-family: 'NotoSansCJKkr-Bold';
    src: local('NotoSansCJKkr-Bold'), url(${NotoSansCJKkrBold}) format('woff');
}

@font-face {
    font-family: 'Poppins-Bold';
    src: local('Poppins-Bold'), url(${PoppinsBold}) format('woff');
}

@font-face {
    font-family: 'Poppins-Regular';
    src: local('Poppins-Regular'), url(${PoppinsRegular}) format('woff');
}
@font-face {
    font-family: 'ErasITC-Bold';
    src: local('ErasITC-Bold'), url(${ErasITCBold}) format('woff');
}

@keyframes opacity {
  from {
      opacity: 1;
  }

  to {
      opacity: 0;
  }
}

  * {
    margin: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  html {
    font-size: 14px;
  }
  body {
    height: 100%;
  }
  a, button {
    text-decoration: none;
    cursor: pointer;
  }

  h1 {
    ${theme('fontStyle.h3')}
  }

  h2 {
    ${theme('fontStyle.h4')}
  }

  h2 {
    ${theme('fontStyle.h5')}
  }

  h3 {
    ${theme('fontStyle.subtitle1')}
  }

  h4 {
    ${theme('fontStyle.subtitle2')}
  }

  h5 {
    ${theme('fontStyle.body1')}
  }

  text{
    font-family: 'NotoSansCJKkr-Bold';
  }

  p {
    ${theme('fontStyle.body2')}
  }
  .hljs{
    background: #000000;
  }
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;
  ::-webkit-scrollbar {
    display: none;
  }
  outline : none;
`;

export default GlobalStyles;

